export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/chris-profile-64680fe5ac6f42984c7bc745d46ec009.png";